<template>
  <address-blank-form
    submit-label="Добавить адрес"
    :address="address"
    :errors="errors"
    form-type="add"
    @submit="processAddressForm"
  />
</template>

<script>
import helpers from '@/helpers'
import { addAddress } from '@/services/address.service'
import addressBlankForm from '@/components/forms/address/AddressBlankForm'

export default {
  name: 'address-add-form',
  components: { addressBlankForm },
  props: {
    district: {
      type: [Number]
    }
  },
  data () {
    return {
      address: {
        id: null,
        name: '',
        district: this.district
      },

      errors: {
        address: {
          id: [],
          name: [],
          district: []
        }
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,

    processAddressForm () {
      this.addAddress().then((success) => {
        if (success) {
          this.showMsg('Адрес был успешно добавлен!', 'success', 'Успешно')
          this.$emit('after', true)
        } else {
          this.$emit('after', false)
        }
      })
    },
    addAddress () {
      return addAddress(this.address).then((response) => {
        this.address = response.data
        this.fillErrors(this.errors.address, {})
        return true
      }).catch(err => {
        this.fillErrors(this.errors.address, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.$parent.$parent.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// AddressAddForm.vue?ed98bac8